export default __webpack_public_path__ + "static/media/floor-9.e1b96a68.jpg";